import { Component, EventEmitter, OnInit, Output } from "@angular/core";

import { fadeInOut } from "src/app/animations/animations";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-score",
  templateUrl: "./score.component.html",
  styleUrls: ["./score.component.scss"],
  animations: [fadeInOut],
})
export class ScoreComponent implements OnInit {
  @Output() onRoute = new EventEmitter<void>();

  gamePoints: number = 0;
  timer: any = { minutes: "00", seconds: "00" };

  constructor() {}

  ngOnInit(): void {
    const userPoints = localStorage.getItem(environment.storage);
    const userTime = localStorage.getItem(environment.storage + "-time");

    if (userPoints) {
      if (typeof +userPoints === "number") {
        this.gamePoints = +userPoints;
      }
    }

    if (userTime && !isNaN(+userTime)) {
      this.formatTime(+userTime);
    }
  }

  formatTime(time: number) {
    const minutes = Math.floor(time / 60) % 60;
    const seconds = Math.floor(time % 60);

    this.timer.minutes = minutes.toString().padStart(2, "0");
    this.timer.seconds = seconds.toString().padStart(2, "0");
  }

  clearSession() {
    localStorage.clear();
    this.changeRoute();
  }

  changeRoute() {
    this.onRoute.emit();
  }
}
